import { HangoutState } from '../state/HangoutState.js';
import { getGlobalHistoryMessages } from '../shared/history-resolution.js';

const MESSAGE_KEY_MAX_LENGTH = 50;

export function encodeMessageKey(messageText) {
    if (!messageText) return 'nomessage';

    try {
        const encoded = btoa(unescape(encodeURIComponent(messageText)));
        if (encoded && encoded.length > 0) {
            return encoded.slice(0, MESSAGE_KEY_MAX_LENGTH);
        }
    } catch (error) {
        console.warn('encodeMessageKey: Failed to encode message text, falling back to sanitized substring:', error);
    }

    const sanitized = messageText.replace(/\s+/g, ' ').trim();
    if (sanitized.length === 0) {
        return 'nomessage';
    }
    return sanitized.slice(0, MESSAGE_KEY_MAX_LENGTH);
}

// Find message path by matching bubble text with stored messages.
export const findMessageIdByText = async (characterId, messageText) => {
    const hangoutState = HangoutState.getInstance();
    const stored = getGlobalHistoryMessages();
    const messages = stored.length > 0 ? stored : (hangoutState.getMessages() || []);
    if (!messages.length) return null;

    const cleanBubbleText = messageText.trim().replace(/\s+/g, ' ');

    for (let i = messages.length - 1; i >= 0; i--) {
        const message = messages[i];

        if (message.role === 'assistant' &&
            String(message.characterId) === String(characterId)) {
            const cleanStoredText = (message.content || '').trim().replace(/\s+/g, ' ');

            if (cleanStoredText === cleanBubbleText) {
                const firstAssistantMessage = messages.find(msg => msg.role === 'assistant');
                if (firstAssistantMessage && message.path === firstAssistantMessage.path) {
                    return '1';
                }
                return message.path;
            }

            if (cleanStoredText.includes(cleanBubbleText) && cleanBubbleText.length > 10) {
                const firstAssistantMessage = messages.find(msg => msg.role === 'assistant');
                if (firstAssistantMessage && message.path === firstAssistantMessage.path) {
                    return '1';
                }
                return message.path;
            }

            if (cleanBubbleText.includes(cleanStoredText) && cleanStoredText.length > 10) {
                const firstAssistantMessage = messages.find(msg => msg.role === 'assistant');
                if (firstAssistantMessage && message.path === firstAssistantMessage.path) {
                    return '1';
                }
                return message.path;
            }
        }
    }

    return null;
};
